<template>
    <div v-if="widgetReady">
        <div v-if="!hideSectionTitle" class="row" style="margin-bottom: 0.5rem;">
            <div class="col-md-12">
                <h4>Additional Family Members</h4>
            </div>
        </div>
        <div v-if="unfinishedMembers && unfinishedMembersWarning" class="row" style="margin-bottom: 0.5rem;">
            <div class="col-md-12">
                <p class="acressaRedText">
                    {{unfinishedMessage}}
                </p>
            </div>
        </div>
        
        <div v-if="dependents.length>0" class="margin-bottom-3">
            <div v-for="(d, index) in dependents">
                <div v-if="d.editMode == false" class="row margin-bottom-3">
                    <div class="col-sm-9 word-break-all pb-2">
                        {{ d.relationshipObject.relationType }} | {{ d.contactInfo.firstName }} {{ d.contactInfo.lastName }} | DOB: {{ d.birthDate }}
                    </div>
                    <div class="col-sm-3 pb-2 dependent-action-buttons">
                        <button
                            type="button"
                            :disabled="isRowBeingEdited"
                            class="btn btn-success btn-sm"
                            @click.prevent="() => { d.editMode = true }"
                        >
                            EDIT
                        </button>
                        <button
                            type="button"
                            :disabled="isRowBeingEdited"
                            class="btn btn-danger btn-sm"
                            @click.prevent="() => deleteDependent(index, true)"
                        >
                            DELETE
                        </button>
                    </div>
                </div>
                <div v-else class="row">
                    <div class="col-lg-9">
                        <add-dependent-form :data-key="index" ref="dependentEditForm" v-model="dependents[index]" :ssn-required="ssnRequired" :company-id="companyId"></add-dependent-form>
                    </div>
                    <div class="col-lg-3 margin-top-15 dependent-action-buttons">
                        <button type="button" class="btn btn-success btn-sm" @click.prevent="() => saveEdit(index)">
                            SAVE
                        </button>
                        <button type="button" class="btn btn-default btn-sm" @click.prevent="() => { d.editMode = false }">
                            CANCEL
                        </button>
                    </div>
                </div>
            </div>
            <hr/>
        </div>

        <div v-if="addDependentForm" class="row">
            <div class="col-lg-9">
                <add-dependent-form ref="dependentForm" v-model="dependentToBeAdded" :ssn-required="ssnRequired" :company-id="companyId"></add-dependent-form>
            </div>
            <div class="col-lg-3 margin-top-15 dependent-action-buttons">
                <button type="button" class="btn btn-success btn-sm" @click.prevent="addDependentToList">
                    ADD
                </button>
                <button type="button" class="btn btn-danger btn-sm" @click.prevent="deleteDependent">
                    DELETE
                </button>
            </div>
        </div>
        <div v-else class="row">
            <div class="col-lg-12 form-group dependent-action-buttons">
                <button type="button" class="btn btn-success btn-sm dependent-btn-wide" @click.prevent="addDependent">
                    ADD MEMBER
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import {formatter} from "@/global/formatter.js";
    import {configTables} from "@/global/configTables.js";
    import {api} from "@/global/framework/api.js";
    import AddDependentForm from "@/components/shared/consumer/AddDependentForm.vue";
    import {notifications} from "@/global/notifications.js";
    import {common} from "@/global/common.js";

    export default {
        name: "AddDependent",
        components: {AddDependentForm},
        props: {
            /** When true, omit the "Additional Family Members" heading (e.g. parent uses BarCard title). */
            hideSectionTitle: {
                type: Boolean,
                default: false,
            },
            ssnRequired: {
                type: Boolean,
                default: false,
            },
            companyId: {
                type: Number,
                default: 0,
            },
        },
        data() {
            return {
                dependents: [],
                addDependentForm: false,
                unfinishedMembersWarning: false,
                dependentTemplate: {},
                dependentToBeAdded: {},
                widgetReady: false,
            }
        },
        computed: {
            isRowBeingEdited() {
                if (this.dependents.some(d => d.editMode == true)) {
                    return true;
                }
                return false;
            },
            unfinishedMembers() {
                return this.addDependentForm || this.isRowBeingEdited;
            },
            unfinishedMessage() {
                return "Some family member information appears unfinished. " +
                    "Please click add or save for each of them to proceed.";
            }
        },
        methods: {
            async addDependent() {
                this.addDependentForm = true;
            },
            async addDependentToList() {
                let newDependent = await this.$refs.dependentForm.getDependent();
                if (newDependent.isSpouse && this.checkForSpouse()) {
                    return;
                }
                if (newDependent) {
                    this.dependents.push(newDependent);
                    this.addDependentForm = false;
                }

            },
            async saveEdit(index) {
                let editRef = this.$refs.dependentEditForm.find(
                    el => el.$attrs['data-key'] === index
                );
                let newDependent = await editRef.getDependent();
                if (newDependent.isSpouse && this.checkForSpouse(index)) {
                    return;
                }
                this.$set(this.dependents, index, newDependent);
            },
            async deleteDependent(index = 0, fromList = false) {
                if (fromList) {
                    if (this.dependents.length != 0) {
                        this.dependents.splice(index, 1);
                    }
                }
                this.dependentToBeAdded = this.clone(this.dependentTemplate);
                if (!fromList) {
                    this.addDependentForm = false;
                }
            },
            getRelationshipType(id) {
                let relationship = this.relationships.find(({RelationshipsEnum}) => RelationshipsEnum === id);
                return relationship.relationType;
            },
            validateDependents() {
                if (this.addDependentForm || this.isRowBeingEdited) {
                    this.unfinishedMembersWarning = true;
                    notifications.show(
                        {title: this.unfinishedMessage}, 
                        common.ACRESSA_NOTIFICATIONS.ERROR
                    );
                    return false;
                }
                return true;
            },
            getAllDependents() {
                return this.dependents;
            },
            checkForSpouse(index) {
                let otherDependents = [...this.dependents];
                if (index !== undefined) {
                    otherDependents.splice(index, 1);
                }
                if (otherDependents.some(d => d.isSpouse == true)) {
                    notifications.show({
                            title: "Only one spouse allowed at a time",
                        },
                        common.ACRESSA_NOTIFICATIONS.ERROR);
                    return true;
                }
                return false;
            }
        },
        async mounted() {
            let action = "GetChildTemplate";
            let template = await api.getData('ProviderSearch', '', action);
            this.mapData('dependentTemplate', template);
            this.mapData('dependentToBeAdded', template);
            this.widgetReady = true;
        },
    }
</script>

<style scoped>
    button[disabled],
    button[disabled]:hover,
    button[disabled]:focus {
        opacity: .5;
    }

    .dependent-action-buttons {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;
        align-items: center;
    }

    .dependent-action-buttons .btn {
        min-width: 6.5rem;
    }

    /*
     * Beat .ac-white-panel * { color: #3e3f40 !important } (baseBs5Whitelabel.css) when this
     * component is used inside BarCard / other ac-white-panel wrappers.
     */
    .dependent-action-buttons >>> .btn.btn-success,
    .dependent-action-buttons >>> .btn.btn-success:hover,
    .dependent-action-buttons >>> .btn.btn-success:focus,
    .dependent-action-buttons >>> .btn.btn-success:active {
        color: #fff !important;
    }

    .dependent-action-buttons >>> .btn.btn-danger,
    .dependent-action-buttons >>> .btn.btn-danger:hover,
    .dependent-action-buttons >>> .btn.btn-danger:focus,
    .dependent-action-buttons >>> .btn.btn-danger:active {
        color: #fff !important;
    }

    .dependent-action-buttons >>> .btn.btn-default,
    .dependent-action-buttons >>> .btn.btn-default:hover,
    .dependent-action-buttons >>> .btn.btn-default:focus,
    .dependent-action-buttons >>> .btn.btn-default:active {
        color: #333 !important;
    }

    .dependent-btn-wide {
        min-width: 10rem;
    }

    .margin-top-15 {
        margin-top: 15px;
    }

    .margin-bottom-3 {
        margin-bottom: 3px;
    }

    .word-break-all {
        word-break: break-all;
    }
</style>